export function setPack(pack) {
    return dispatch => {
        return dispatch({
            type: 'TESTBENCH__SET_PACK',
            pack: pack
        });
    };
}



// WEBPACK FOOTER //
// ./environments/testbench/data/Packs/actions.js